import * as React from 'react'
import styled from 'styled-components'
import PaypalButton from './PaypalButton'
import { theme } from 'containers/GlobalStyle'

export default function PaypalExpress() {
  return (
    <Wrapper className="PaypalButton" data-cy-collection="PaypalExpress">
      <div className="paypal-wrapper">
        <PaypalButton />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  min-height: 40px;

  > .paypal-wrapper {
    position: relative;
    > .overlay {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: ${theme.zIndex
        .theme_molecules_account_cartsummary_paypalexpress};
      cursor: pointer;
      background: transparent;
    }
  }
`
